import { extractLast } from 'alto-utils/lib/utils';

// class Delegator
//   delegate(@, 'map', 'forEach', 'find', to: 'entityMap')
export function delegate(cls, ...args) {
  const [methodNames, options] = extractLast(args)

  methodNames.forEach(name => {
    cls.prototype[name] = function(...args) {
      const receiver = this[options.to];

      return receiver[name].apply(receiver, args);
    };
  });
};

// class Delegator
//   wrap(@, 'where', 'orderBy', around: 'entityMap', wrapperMethod: '_withMap')
export function wrap(cls, ...args) {
  const [methodNames, options] = extractLast(args)

  methodNames.forEach(name => {
    cls.prototype[name] = function(...args) {
      const receiver = this[options.around];

      return this[options.wrapperMethod](receiver[name].apply(receiver, args));
    };
  });
};
